import styled from "styled-components";

export const Categories = styled.div<{ $glowAnchor?: boolean }>`
  ${props => (props.$glowAnchor ? "position: relative;" : "")}
  display: flex;
  width: 100%;
`;
